import { Injectable } from '@angular/core';
import { CustomerSearchPage } from '@spartacus/asm/root';
import { Converter, ConverterService, User } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class KbUserAccountNormalizer implements Converter<any, User> {
  constructor(private converterService: ConverterService) {}

  convert(source: any, target: User): User {
    target = {};
    target.lastCartId = source?.userWS?.cartId;
    target.displayUid = source?.userWS?.displayUid;
    target.firstName = source?.userWS?.firstName;
    target.language = source?.userWS?.language;
    target.lastName = source?.userWS?.lastName;
    target.name = source?.userWS?.name;
    target.uid = source?.userWS?.displayUid;
    return target;
  }
}
